/**
 * Created by Timur on 27.07.2026
 */

Mission.TYPE_BALLOON_RISE = 104;

Mission.REGISTRATIONS.set(Mission.TYPE_BALLOON_RISE, () => ({
    available: cleverapps.config.availables.BALLOON_RISE_MISSION,
    name: "BalloonRise",
    logic: BalloonRise,
    view: BalloonRiseWindow,
    startWindow: BalloonRiseStartWindow,
    stages: bundles.balloon_rise_stages.jsons.stages_config_json.getJson(),
    schedule: "FRI-MON",
    semaphore: Mission.SEMAPHORE_ALWAYS,
    bundle: "balloon_rise",
    sideBarJson: cleverapps.config.type === "merge2" ? bundles.sidebar.jsons.balloonrise_icon_json : false,
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.merge.jsons.balloonrise_row_prefab_json, { mission: row.data.mission });
    } : undefined
}));
